export default "__VITE_ASSET__4ac6a86b__"